import { SVGProps } from 'react';

const ThumbScaleMediumKindDownReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M15 5V13.5M19 11.3V6.4C19 5.6268 18.3573 5 17.5644 5H7.92691C6.86404 5 5.96015 5.75623 5.79853 6.78068L5.0255 11.6807C4.82482 12.9528 5.83409 14.1 7.15389 14.1H9.66849C10.0649 14.1 10.3863 14.4134 10.3863 14.8V17.2739C10.3863 18.2272 11.1788 19 12.1563 19C12.3895 19 12.6008 18.8661 12.6954 18.6583L15.2215 13.1157C15.3367 12.8629 15.5938 12.7 15.8774 12.7H17.5644C18.3573 12.7 19 12.0732 19 11.3Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleMediumKindDownReducedTrue;
